import colors from "theme/colors"

const SvgComponent = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="שגיאה"
    >
      <g clip-path="url(#clip0_15796_42498)">
        <path
          d="M10 22.4063L22 9.40625"
          stroke={colors.dangerRed}
          stroke-width="1.71429"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22 22.4063L10 9.40625"
          stroke={colors.dangerRed}
          stroke-width="1.71429"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_15796_42498">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgComponent
